import { Component } from '@angular/core'
import { AdvertCtaItemComponent } from '../advert-cta-item/advert-cta-item.component'
import { AdvertCtaItemTitleComponent } from '../advert-cta-item/advert-cta-item-title.component'
import { AdvertCtaItemContentComponent } from '../advert-cta-item/advert-cta-item-content.component'
import { AdvertCtaComponent } from '../advert-cta/advert-cta.component'

@Component({
    selector: 'sf-wolseley-cta',
    imports: [AdvertCtaComponent, AdvertCtaItemComponent, AdvertCtaItemTitleComponent, AdvertCtaItemContentComponent],
    template: `
        <sf-advert-cta
            adLogo="assets/images/wolseley/logo.png"
            adTitle="Connect to Wolseley with Surefire. Work smarter, not harder"
            adContent="One of the UK's leading merchants in plumbing, heating, cooling and infrastructure">
            <p class="fw-bold">Get in touch with support today to find out more.</p>

            <sf-advert-cta-item icon="user" image="assets/adverts/wolseley.jpg">
                <sf-advert-cta-item-title>Stock Availability</sf-advert-cta-item-title>
                <sf-advert-cta-item-content
                    >Check live stock availability in any of our branches or distribution
                    centres</sf-advert-cta-item-content
                >
            </sf-advert-cta-item>
            <sf-advert-cta-item image="assets/adverts/wolseley.jpg">
                <sf-advert-cta-item-title>Live Prices</sf-advert-cta-item-title>
                <sf-advert-cta-item-content
                    >View your live personalised trade account prices</sf-advert-cta-item-content
                >
            </sf-advert-cta-item>
            <sf-advert-cta-item image="assets/adverts/wolseley.jpg">
                <sf-advert-cta-item-title>Order & Collection</sf-advert-cta-item-title>
                <sf-advert-cta-item-content
                    >Order for collection from any branch or we deliver direct to your home, office or
                    site</sf-advert-cta-item-content
                >
            </sf-advert-cta-item>
        </sf-advert-cta>
    `,
})
export class WolseleyCtaComponent {}
